import React from 'react';
import { Footer } from '../../../common/footer/footer';
import 'aos/dist/aos.css';
import Sidebar from "../sidebar/sidebar.js";

export const CustomerAskTheExpertJsx = (props) => {
  const {
    userData,
    selectedUsers,
    handleUserSelection,
    handleBulkAction,
    currentPage,
    totalPages,
    totalCount,
    handlePageChange,
    showAddUserModal,
    showEditUserModal,
    showModal,
    modalMode,
    formData,
    roles,
    handleInputChange,
    handleSubmit,
    closeModal
  } = props;

  // Get user type badge color
  const getUserTypeBadgeColor = (userType) => {
    switch(userType) {
      case 'super-admin': return 'bg-danger';
      case 'marketing': return 'bg-primary';
      case 'support': return 'bg-success';
      default: return 'bg-secondary';
    }
  };

  return (
    <>
      <section className="entiredashboard admindashboard py-5 bg-light">
        <div className="container">
          <div className="row">
            {/* Sidebar */}
            <div className="col-lg-3 col-sm-12 mb-4">
              <div className="dashboardleftpanel p-3 bg-white shadow rounded">
                <Sidebar />
              </div>
            </div>

            {/* Main Content */}
            <div className="col-lg-9 col-sm-12">
              <div className="dashboardrightpanel p-4 bg-white shadow rounded">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h2 className="text-primary mb-0">User Management</h2>
                  <div className="d-flex gap-2 align-items-center">
                    <button 
                      onClick={showAddUserModal}
                      className="btn btn-primary btn-sm"
                    >
                      <i className="fas fa-plus me-2"></i>
                      Add User
                    </button>
                    <span className="badge bg-info fs-6">Total Users: {totalCount}</span>
                    {selectedUsers.length > 0 && (
                      <span className="badge bg-warning fs-6">Selected: {selectedUsers.length}</span>
                    )}
                  </div>
                </div>

                {/* Bulk Actions */}
                {selectedUsers.length > 0 && (
                  <div className="mb-4 p-3 bg-light border rounded">
                    <h6 className="mb-3">Bulk Actions</h6>
                    <div className="d-flex gap-2">
                      <button 
                        onClick={() => handleBulkAction('activate')} 
                        className="btn btn-success btn-sm"
                      >
                        Activate Selected
                      </button>
                      <button 
                        onClick={() => handleBulkAction('deactivate')} 
                        className="btn btn-warning btn-sm"
                      >
                        Deactivate Selected
                      </button>
                      <button 
                        onClick={() => handleBulkAction('delete')} 
                        className="btn btn-danger btn-sm"
                      >
                        Delete Selected
                      </button>
                    </div>
                  </div>
                )}

                <div className="usersection">
                  {userData?.length > 0 ? (
                    <>
                      <div className="table-responsive">
                        <table className="table table-striped table-hover">
                          <thead className="table-dark">
                            <tr>
                              <th width="50">Select</th>
                              <th>Name</th>
                              <th>Email</th>
                              <th>Phone</th>
                              <th>User Type</th>
                              {/* <th>Role</th> */}
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {userData.map((user, index) => (
                              <tr key={user.userId}>
                                <td>
                                  <div className="form-check">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      checked={selectedUsers.includes(user.userId)}
                                      onChange={(e) => handleUserSelection(user.userId, e.target.checked)}
                                      id={`user-${user.userId}`}
                                    />
                                  </div>
                                </td>
                                <td className="fw-bold">{user.name}</td>
                                <td>{user.email}</td>
                                <td>{user.phoneNumber || 'N/A'}</td>
                                <td>
                                  <span className={`badge ${getUserTypeBadgeColor(user.userType)}`}>
                                    {user.userType}
                                  </span>
                                </td>
                                {/* <td>{user.role || 'No Role Assigned'}</td> */}
                                <td>
                                  <div className="d-flex gap-1">
                                    <button 
                                      className="btn btn-sm btn-outline-primary"
                                      onClick={() => showEditUserModal(user)}
                                    >
                                     Edit
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      {/* Pagination */}
                      {totalPages > 1 && (
                        <div className="d-flex justify-content-between align-items-center mt-4">
                          <div>
                            <small className="text-muted">
                              Showing page {currentPage} of {totalPages}
                            </small>
                          </div>
                          <nav>
                            <ul className="pagination pagination-sm mb-0">
                              <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                <button 
                                  className="page-link"
                                  onClick={() => handlePageChange(currentPage - 1)}
                                  disabled={currentPage === 1}
                                >
                                  Previous
                                </button>
                              </li>
                              
                              {[...Array(totalPages)].map((_, index) => {
                                const pageNum = index + 1;
                                return (
                                  <li 
                                    key={pageNum} 
                                    className={`page-item ${currentPage === pageNum ? 'active' : ''}`}
                                  >
                                    <button 
                                      className="page-link"
                                      onClick={() => handlePageChange(pageNum)}
                                    >
                                      {pageNum}
                                    </button>
                                  </li>
                                );
                              })}
                              
                              <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                <button 
                                  className="page-link"
                                  onClick={() => handlePageChange(currentPage + 1)}
                                  disabled={currentPage === totalPages}
                                >
                                  Next
                                </button>
                              </li>
                            </ul>
                          </nav>
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="text-center py-5">
                      <i className="fas fa-users fa-3x text-muted mb-3"></i>
                      <p className="text-muted">No users found.</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Add/Edit User Modal */}
      {showModal && (
        <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {modalMode === 'add' ? 'Add New User' : 'Edit User'}
                </h5>
                <button 
                  type="button" 
                  className="btn-close" 
                  onClick={closeModal}
                ></button>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">
                        Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={formData.name}
                        onChange={(e) => handleInputChange('name', e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">
                        Email <span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        value={formData.email}
                        onChange={(e) => handleInputChange('email', e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Phone Number</label>
                      <input
                        type="tel"
                        className="form-control"
                        value={formData.phoneNumber}
                        onChange={(e) => handleInputChange('phoneNumber', e.target.value)}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">User Type</label>
                      <select
                        className="form-select"
                        value={formData.userType}
                        onChange={(e) => handleInputChange('userType', e.target.value)}
                      >
                        <option value="marketing">Marketing</option>
                        <option value="support">Support</option>
                        <option value="super-admin">Super Admin</option>
                      </select>
                    </div>
                  </div>
                  
                  <div className="row">
                    <div className="col-md-12 mb-3">
                      <label className="form-label">
                        Role <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-select"
                        value={formData.roleId}
                        onChange={(e) => handleInputChange('roleId', e.target.value)}
                        required
                      >
                        <option value="">Select Role</option>
                        {roles.map(role => (
                          <option key={role.roleId} value={role.roleId}>
                            {role.roleName} - {role.access}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button 
                    type="button" 
                    className="btn btn-secondary" 
                    onClick={closeModal}
                  >
                    Cancel
                  </button>
                  <button 
                    type="submit" 
                    className="btn btn-primary"
                  >
                    {modalMode === 'add' ? 'Add User' : 'Update User'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      
      {/* Modal backdrop */}
      {showModal && <div className="modal-backdrop fade show"></div>}

      <Footer />
    </>
  );
};

export default CustomerAskTheExpertJsx;